class BrixModuleEvent {
  static init(...parameters) {
    return new BrixModuleEvent(...parameters);
  }

  constructor(selector) {
    this.selector = selector;

    this.setUpCalendar();
  }

  setUpCalendar() {
    const calendarButton = this.selector.querySelector('.calendar-button');
    const calendarList = this.selector.querySelector('.calendar-options');
    let isHidden = calendarList.classList.contains('-hidden');

    if (calendarButton && calendarList) {
      calendarButton.addEventListener('click', () => {
        if (isHidden) {
          calendarList.classList.remove('-hidden');
        } else {
          calendarList.classList.add('-hidden');
        }

        isHidden = !isHidden;
      });
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-event', BrixModuleEvent.init);
}
